import { useState } from "react";
import { Plus, Copy, Trash2, Puzzle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PanelHeader } from "./PagesPanel";
import { OriginBadge } from "./SectionsPanel";
import { useEditor } from "./useEditorState";

const PLACEMENT = { header: "Header (tutte le pagine)", footer: "Footer (tutte le pagine)", none: "Riutilizzabile" };
const starter = (name) => `import React from 'react';\n\nexport default function ${name}() {\n  return (\n    <div className="p-6 rounded-theme bg-surface text-ink">${name}</div>\n  );\n}\n`;

export default function ComponentsPanel() {
  const ed = useEditor();
  const [name, setName] = useState("");
  const add = () => {
    const n = (name.trim() || "NuovoComponente").replace(/[^A-Za-z0-9]/g, "").replace(/^./, (c) => c.toUpperCase());
    const id = ed.addComponent({ name: n, code: starter(n) });
    ed.setSelection({ kind: "component", id }); ed.setUi({ rightTab: "code", rightOpen: true }); setName("");
  };
  return (
    <div data-testid="components-panel">
      <PanelHeader title="Componenti" subtitle="Condivisi tra le pagine" />
      <div className="px-4 flex gap-2">
        <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="NomeComponente" className="h-8 text-sm" data-testid="new-component-name-input" />
        <Button size="sm" className="h-8" variant="outline" onClick={add} data-testid="add-component-btn"><Plus size={14} /></Button>
      </div>
      <ul className="mt-3 px-2 space-y-0.5">
        {ed.content.components.map((c) => (
          <li key={c.id} className={`group flex items-center rounded-md pr-1 ${ed.selection?.id === c.id ? "bg-sky-50 ring-1 ring-sky-400" : "hover:bg-slate-100"}`}>
            <button className="flex-1 min-w-0 text-left px-3 py-2" onClick={() => ed.setSelection({ kind: "component", id: c.id })} data-testid={`component-item-${c.name}`}>
              <p className="text-sm text-slate-800 truncate flex items-center gap-1.5"><Puzzle size={13} className="text-slate-400" />{c.name}</p>
              <div className="mt-1 flex items-center gap-1.5"><OriginBadge origin={c.origin} /><span className="text-[10px] text-slate-500">{PLACEMENT[c.placement]}</span></div>
            </button>
            <button className="p-1.5 text-slate-400 hover:text-slate-800" onClick={() => ed.duplicateComponent(c.id)} aria-label="Duplica"><Copy size={14} /></button>
            <button className="p-1.5 text-slate-400 hover:text-red-600" onClick={() => ed.setUi({ confirm: { title: `Eliminare il componente ${c.name}?`, description: "Le sezioni che lo importano mostreranno un errore.", onConfirm: () => { ed.deleteComponent(c.id); ed.setSelection(null); } } })} aria-label="Elimina" data-testid={`component-delete-${c.name}`}><Trash2 size={14} /></button>
          </li>
        ))}
      </ul>
      <p className="px-4 py-4 text-[11px] text-slate-500 leading-relaxed">Usa i componenti riutilizzabili nelle sezioni con <code className="text-[10.5px] bg-slate-100 px-1 rounded">{"import { Nome } from 'components'"}</code>.</p>
    </div>
  );
}
